import { ApiType } from "@gymflow/common";
import { zonedTimeToUtc } from "@gymflow/helpers";
import { ApiListResponse, NoVisitReportDTO } from "@gymflow/types";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { reportQueryKeys } from "./reportQueryKeys";

export interface UseQueryNoVisitReportProps {
  api: ApiType;
  dateFrom?: string;
  dateTo?: string;
  page?: number;
  size?: number;
  tz: string;
}

export function useQueryNoVisitReport(
  { api, dateFrom, dateTo, page, size, tz }: UseQueryNoVisitReportProps,
  queryOpts?: Omit<
    UseQueryOptions<ApiListResponse<NoVisitReportDTO>>,
    "queryKey"
  >,
) {
  const result = useQuery({
    queryKey: reportQueryKeys.noVisit({
      dateFrom,
      dateTo,
      page,
      size,
    }),
    queryFn: async () => {
      const result = await api.accessApi.noVisitReport({
        dateFrom: zonedTimeToUtc(dateFrom as string, tz),
        dateTo: zonedTimeToUtc(dateTo as string, tz),
        page,
        size,
      });
      return result.data;
    },
    enabled: !!tz && !!dateFrom && !!dateTo,
    ...queryOpts,
  });
  return result;
}
